import React, { useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import getTheme from '../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import { TextField, Button, Box, Container, IconButton } from '@mui/material';
import { toast } from 'react-toastify';
import { AUTOFILL_STYLES, BASEURL } from "../constants/Common"
import { useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material'

interface ResetPasswordParams {
  token: string;
  uidb64: string;
  [key: string]: string; // Add index signature
}

const ResetPasswordForm = (): JSX.Element => {
  const navigate = useNavigate();
  const params = useParams<ResetPasswordParams>();
  const { token, uidb64 } = params;
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const theme = getTheme();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (password1 !== password2) {
      toast.error('Passwords do not match');
      return;
    }
    setIsButtonVisible(false); // Hide the button when clicked

    try {
      const response = await axios.post<{ detail: string }>(
        //        `http://localhost:8000/password-reset/confirm/${uidb64}/${token}/`,
        BASEURL + `/password-reset/confirm/${uidb64}/${token}/`,
        { password1, password2 }
      );
      toast.success(response.data.detail);
      navigate('/login');
    } catch (error) {
      toast.error('Failed to reset password. Please try again.');
      setIsButtonVisible(true);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <Container maxWidth='sm'>
        <Box
          sx={{
            marginTop: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <Box sx={{ marginBottom: 2 }}>
              <TextField
                fullWidth
                type={showPassword ? 'text' : 'password'} // Show password if showPassword is true
                label='New Password'
                value={password1}
                onChange={(e) => setPassword1(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={togglePasswordVisibility}
                      edge='end'
                    >
                      {!showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                }}
                sx={{
                  height: '20px',
                  marginBottom: 4,
                  ...AUTOFILL_STYLES(theme),
                }
                }
              />
            </Box>
            <Box sx={{ marginBottom: 2 }}>
              <TextField
                fullWidth
                type={showPassword ? 'text' : 'password'} // Show password if showPassword is true
                label='Confirm Password'
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={togglePasswordVisibility}
                      edge='end'
                    >
                      {!showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                }}
                sx={{
                  height: '20px',
                  marginBottom: 4,
                  ...AUTOFILL_STYLES(theme),
                }
                }
              />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button variant='contained' type='submit' sx={{ '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }} disabled={!isButtonVisible}>
                Reset Password
              </Button>
            </Box>
          </form>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default ResetPasswordForm;
